import React from 'react';
import './CommitteeMembers.css';
import Navbar from '../../components/navigationbar/Navbar';
import Footer from '../../components/Footer/Footer';
import bg1 from '../../assets/bg-images/bg1.jpg';
import img1 from '../../assets/members/Dr.Abhijit Pandurang Bhosale.jpeg';
import img2 from '../../assets/members/Dr.Suhas Kumbhar.jpeg'
import img3 from '../../assets/members/Dr.Rahul Kore.jpeg'
import img6 from '../../assets/members/Dr.Govardhan Powar.jpg';
import img7 from '../../assets/members/Dr.Mahesh Ayevale.jpg';
import img8 from '../../assets/members/Dr.Rahim Khan.jpeg';
import img9 from '../../assets/members/Dr.Sandip Koparde.jpg';
import img10 from '../../assets/members/Dr.Sarika G. Powar.jpg';
import img11 from '../../assets/members/Dr.Vijay Chougule.jpg';
import img4 from '../../assets/members/Dr.Apurva Koparde.jpeg';
import img5 from '../../assets/members/Dr.Nadeem Patel.jpeg';
const CommitteeMembers = () => {
  const members = [
    {name:'Dr.Nadeem Patel', role:'Member', photo:img5},//1
    { name: 'Dr.Rahim Khan', role: 'Member', photo: img8 },//2
    { name: 'Dr.Govardhan Powar', role: 'Member', photo: img6 },//3
    {name:'Dr.Abhijit P. Bhosale', role:'Member',photo:img1},//4
    { name: 'Dr.Mahesh Aywale ', role: 'Member', photo: img7 },//5
    {name:'Dr.Suhas Kumbhar', role:'Member',photo:img2},
    {name:'Dr.Rahul Kore', role:'Member', photo:img3},
    { name: 'Dr.Vijay Chougule', role: 'Member', photo: img11 },
    { name: 'Dr.Sandip Koparde', role: 'Member', photo: img9 },
    { name: 'Dr.Sarika G. Powar', role: 'Member', photo: img10 },
    {name:'Dr.Apurva Koparde', role:'Member', photo:img4},
   
   
    
   
   
    
   
  ];

  return (
    <>
      <Navbar />
      <div className="committee-page">
        {/* Carousel Section */}
        <div className="carousel">
          <div className="carousel-slider">
            <img className="bg-image" src={bg1} alt="Committee" />
          </div>
          <div className="carousel-caption">
            <h1>Leadership Committee</h1>
          </div>
        </div>

        {/* Description Section */}
        <div className="committee-description">
          <p>
            The General Practitioners Association of Ichalkaranji (GPAI) is proud to present
            its Leadership Committee, comprising experienced professionals who guide the
            association with dedication and a shared commitment to enhancing healthcare
            standards. These esteemed members are integral to GPAI's mission of providing
            quality healthcare to the community.
          </p>
        </div>

        {/* Committee Members Section */}
        <div className="committee-container">
          {members.map((member, index) => (
            <div key={index} className="committee-member">
              <img src={member.photo} alt={member.name} className="member-photo" />
              <div className="member-details">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-role">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CommitteeMembers;
